import { render, staticRenderFns } from "./RegistrationWithJobPostingDialog.vue?vue&type=template&id=22f5b8a4&"
import script from "./RegistrationWithJobPostingDialog.vue?vue&type=script&lang=js&"
export * from "./RegistrationWithJobPostingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VDialog})
